import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = 'https://sistemafinanciero.digitaleseduproperu.com/api';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const meses = [
  'Enero','Febrero','Marzo','Abril','Mayo','Junio',
  'Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'
];

export default function NominaPage() {
  const hoy = new Date();
  const [mes, setMes]       = useState(hoy.getMonth() + 1);
  const [anio, setAnio]     = useState(hoy.getFullYear());
  const [nomina, setNomina] = useState([]);
  const [resumen, setResumen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg]       = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem]   = useState(null);
  const [form, setForm]           = useState({});

  useEffect(() => { cargar(); }, [mes, anio]);

  const cargar = async () => {
    try {
      const [n, r] = await Promise.all([
        axios.get(`${API}/nomina`, { headers: headers(), params: { mes, anio } }),
        axios.get(`${API}/nomina/resumen-total`, { headers: headers(), params: { mes, anio } }),
      ]);
      setNomina(n.data);
      setResumen(r.data);
    } catch (e) { console.error(e); }
  };

  const generar = async () => {
    if (!window.confirm(`¿Generar nómina para ${meses[mes-1]} ${anio}?`)) return;
    setLoading(true); setMsg('');
    try {
      const res = await axios.post(`${API}/nomina/generar`, { mes: parseInt(mes), anio: parseInt(anio) }, { headers: headers() });
      setMsg(`✅ ${res.data.message} — ${res.data.generados} empleado(s) procesado(s).`);
      cargar();
    } catch (e) {
      setMsg('❌ Error al generar nómina.');
    } finally { setLoading(false); }
  };

  const abrirEditar = (item) => {
    setEditItem(item);
    setForm({
      sueldo_base:        item.sueldo_base,
      dias_trabajados:    item.dias_trabajados,
      dias_falta:         item.dias_falta,
      horas_extra:        item.horas_extra,
      bonificacion:       item.bonificacion,
      descuento_tardanza: item.descuento_tardanza,
      descuento_falta:    item.descuento_falta,
      otros_descuentos:   item.otros_descuentos,
      essalud:            item.essalud,
      afp:                item.afp,
      observacion:        item.observacion || '',
    });
    setShowModal(true);
  };

  const guardar = async () => {
    try {
      await axios.put(`${API}/nomina/${editItem.id}`, form, { headers: headers() });
      setShowModal(false); cargar();
    } catch (e) { console.error(e); }
  };

  const aprobar = async (id) => {
    if (!window.confirm('¿Aprobar esta nómina?')) return;
    try {
      await axios.patch(`${API}/nomina/${id}/aprobar`, {}, { headers: headers() });
      cargar();
    } catch (e) { console.error(e); }
  };

  const marcarPagado = async (id) => {
    if (!window.confirm('¿Marcar como pagado?')) return;
    try {
      await axios.patch(`${API}/nomina/${id}/pagado`, {}, { headers: headers() });
      cargar();
    } catch (e) { console.error(e); }
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar esta nómina?')) return;
    try {
      await axios.delete(`${API}/nomina/${id}`, { headers: headers() });
      cargar();
    } catch (e) { console.error(e); }
  };

  const verBoleta = (id) => {
    window.open(
      `https://sistemafinanciero.digitaleseduproperu.com/api/boletas/${id}?token=${localStorage.getItem('token')}`,
      '_blank'
    );
  };

  const estadoBadge = (estado) => {
    const map = { borrador: 'secondary', aprobado: 'primary', pagado: 'success' };
    return <span className={`badge bg-${map[estado]||'secondary'}`}>{estado}</span>;
  };

  const fmt = (v) => `S/ ${parseFloat(v||0).toFixed(2)}`;

  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold mb-0">
          <i className="fas fa-money-bill-wave me-2 text-primary"></i>Nómina
        </h2>
        <div className="d-flex gap-2 align-items-center">
          <select className="form-select w-auto" value={mes}
            onChange={e => setMes(parseInt(e.target.value))}>
            {meses.map((m, i) => (
              <option key={i+1} value={i+1}>{m}</option>
            ))}
          </select>
          <input type="number" className="form-control w-auto" value={anio}
            onChange={e => setAnio(parseInt(e.target.value))} style={{width:90}} />
          <button className="btn btn-success" onClick={generar} disabled={loading}>
            <i className="fas fa-cogs me-1"></i>
            {loading ? 'Generando...' : 'Generar Nómina'}
          </button>
        </div>
      </div>

      {msg && (
        <div className={`alert ${msg.includes('✅') ? 'alert-success' : 'alert-danger'} mb-3`}>
          {msg}
        </div>
      )}

      {/* Resumen */}
      {resumen && (
        <div className="row g-3 mb-4">
          {[
            { label: 'Empleados',      value: resumen.total_empleados,      icon: 'fa-users',           color: 'primary'   },
            { label: 'Total Ingresos', value: fmt(resumen.total_ingresos),   icon: 'fa-arrow-up',        color: 'success'   },
            { label: 'Descuentos',     value: fmt(resumen.total_descuentos), icon: 'fa-arrow-down',      color: 'danger'    },
            { label: 'Total Neto',     value: fmt(resumen.total_neto),       icon: 'fa-money-bill-wave', color: 'warning'   },
            { label: 'EsSalud',        value: fmt(resumen.total_essalud),    icon: 'fa-heartbeat',       color: 'info'      },
            { label: 'AFP',            value: fmt(resumen.total_afp),        icon: 'fa-piggy-bank',      color: 'secondary' },
          ].map((c, i) => (
            <div key={i} className="col-md-2 col-sm-4 col-6">
              <div className={`card border-${c.color} h-100`}>
                <div className="card-body text-center p-2">
                  <i className={`fas ${c.icon} text-${c.color} mb-1`} style={{fontSize:20}}></i>
                  <div className="fw-bold" style={{fontSize:13}}>{c.value}</div>
                  <small className="text-muted">{c.label}</small>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Tabla */}
      <div className="card">
        <div className="card-header">
          <h5 className="mb-0">
            Nómina — {meses[mes-1]} {anio}
            <span className="ms-2 badge bg-light text-dark border">{nomina.length} registros</span>
          </h5>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover mb-0" style={{fontSize:13}}>
              <thead className="table-light">
                <tr>
                  <th>Empleado</th>
                  <th>Cargo</th>
                  <th className="text-end">Sueldo Base</th>
                  <th className="text-center">Días</th>
                  <th className="text-center">Faltas</th>
                  <th className="text-end">Bonif.</th>
                  <th className="text-end">AFP</th>
                  <th className="text-end">Desc. Total</th>
                  <th className="text-end fw-bold">Neto</th>
                  <th className="text-center">Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {nomina.length === 0
                  ? <tr><td colSpan={11} className="text-center py-4 text-muted">
                      No hay nómina generada para este período. Presiona "Generar Nómina".
                    </td></tr>
                  : nomina.map(n => (
                    <tr key={n.id}>
                      <td>
                        <div className="fw-semibold">{n.empleado_nombre}</div>
                        <small className="text-muted">{n.empleado_codigo}</small>
                      </td>
                      <td><small className="text-muted">{n.cargo}</small></td>
                      <td className="text-end">{fmt(n.sueldo_base)}</td>
                      <td className="text-center">{n.dias_trabajados}</td>
                      <td className="text-center">
                        <span className={`badge ${n.dias_falta > 0 ? 'bg-danger' : 'bg-light text-dark'}`}>
                          {n.dias_falta}
                        </span>
                      </td>
                      <td className="text-end text-success">{fmt(n.bonificacion)}</td>
                      <td className="text-end text-danger">{fmt(n.afp)}</td>
                      <td className="text-end text-danger">{fmt(n.total_descuentos)}</td>
                      <td className="text-end fw-bold text-success">{fmt(n.sueldo_neto)}</td>
                      <td className="text-center">{estadoBadge(n.estado)}</td>
                      <td>
                        <div className="d-flex gap-1">
                          {n.estado === 'borrador' && (
                            <>
                              <button className="btn btn-sm btn-outline-primary"
                                onClick={() => abrirEditar(n)} title="Editar">
                                <i className="fas fa-edit"></i>
                              </button>
                              <button className="btn btn-sm btn-outline-success"
                                onClick={() => aprobar(n.id)} title="Aprobar">
                                <i className="fas fa-check"></i>
                              </button>
                              <button className="btn btn-sm btn-outline-danger"
                                onClick={() => eliminar(n.id)} title="Eliminar">
                                <i className="fas fa-trash"></i>
                              </button>
                            </>
                          )}
                          {n.estado === 'aprobado' && (
                            <button className="btn btn-sm btn-outline-success"
                              onClick={() => marcarPagado(n.id)} title="Marcar pagado">
                              <i className="fas fa-money-bill"></i>
                            </button>
                          )}
                          {(n.estado === 'aprobado' || n.estado === 'pagado') && (
                            <button className="btn btn-sm btn-outline-secondary"
                              title="Ver Boleta"
                              onClick={() => verBoleta(n.id)}>
                              <i className="fas fa-file-alt"></i>
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Modal Editar */}
      {showModal && editItem && (
        <div className="modal show d-block" style={{background:'rgba(0,0,0,0.5)'}}>
          <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Editar Nómina — {editItem.empleado_nombre}
                </h5>
                <button className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  {[
                    { key: 'sueldo_base',        label: 'Sueldo Base' },
                    { key: 'dias_trabajados',     label: 'Días Trabajados' },
                    { key: 'dias_falta',          label: 'Días Falta' },
                    { key: 'horas_extra',         label: 'Horas Extra' },
                    { key: 'bonificacion',        label: 'Bonificación' },
                    { key: 'descuento_tardanza',  label: 'Desc. Tardanza' },
                    { key: 'descuento_falta',     label: 'Desc. Falta' },
                    { key: 'otros_descuentos',    label: 'Otros Descuentos' },
                    { key: 'essalud',             label: 'EsSalud (9%)' },
                    { key: 'afp',                 label: 'AFP (13%)' },
                  ].map(f => (
                    <div key={f.key} className="col-md-4">
                      <label className="form-label">{f.label}</label>
                      <input type="number" className="form-control" step="0.01"
                        value={form[f.key]}
                        onChange={e => setForm(prev => ({...prev, [f.key]: e.target.value}))} />
                    </div>
                  ))}
                  <div className="col-12">
                    <label className="form-label">Observación</label>
                    <textarea className="form-control" rows={2} value={form.observacion}
                      onChange={e => setForm(prev => ({...prev, observacion: e.target.value}))} />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Cancelar
                </button>
                <button className="btn btn-primary" onClick={guardar}>
                  Guardar Cambios
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}